// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_CloneResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for planocontas/clone endpoint
 *
 * Returns the count of cloned contas
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_CloneResponseDados {
cloned_count: number
message: string
}

export type Planocontas_CloneResponse = ApiResponse<Planocontas_CloneResponseDados>;

registerResponseContract('Planocontas_CloneResponse', {
  cloned_count: { type: 'number',  required: true },
  message:      { type: 'string',  required: true },
})
